/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { Row, Col } from "components/Grid";
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import FileModal from "components/FileModal";
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import DialogComponent, { DialogConfirm, DialogRejected, ContentTextArea, TextArea2 } from 'components/Dialog';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { TextArea } from "./styles";
import { LostCancelButton } from 'components/index';

import DialogComponentCancel from 'components/ModalCancel';
import HasPermission from "components/HasPermission/index";

export default function ApprovalEndorsement(props) {
    const [file, setFile] = useState();
    const [summary, setSummary] = useState({});
    const [userComments, setUserComments] = useState(null);
    const [historymsg, setHistorymsg] = useState([]);
    const [isApproved, setIsApproved] = useState(false);
    const [isBound, setIsBound] = useState(false);

    const authContext = useContext(GlobalAuthContext);
    const formik = useRef(null);
    const history = useHistory();
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    const loading = useContext(GlobalLoaderContext);

    function requestBindMessage() {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.endorsementOffRiskFormData(props.match.params.idOperation)
            .then(x => x.json())
            .then(resp => {
                if (resp.ret_code != 200) {
                    mc.error(resp.ret_msg_details);
                    history.goBack();
                    return;
                }

                if (formik.current) {
                    formik.current?.setFieldValue('offRiskMessage', resp.ret_value.endorsementOffRiskMessage);
                }
            }).catch((error) => {
                mc.error("Erro executando consulta\n" + error);
                console.error('fitPostReject - Error:', error);
            });
    };

    function handleGetModal() {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.endorsementDocHtmlModal(props.match.params.idOperation)
            .then(x => x.json())
            .then(resp => {
                setFile(resp.ret_value)
            }).catch((error) => {
                mc.error("Erro executando consulta\n" + error);
                console.error('fitPostReject - Error:', error);
            });
    };

    function handleHistoryMessage() {
        let tempmessage = "";
        if (historymsg?.length >= 1) {
            historymsg.map(
                (message, index) => {
                    const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
                    tempmessage = (tempmessage + tempMsg);
                }
            )
            return tempmessage;
        }
    };

    function handleSummary() {
        loading.start();
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestHeaderNbi(props.match.params.idOperation)
            .then(response => response.json()).then(data => {
                console.log("Sumario-> ", data.ret_value)
                setSummary({
                    typeOfCover: data.ret_value.typeOfCover,
                    client: data.ret_value.client,
                    obligorCoding: data.ret_value.obligorCoding,
                    responseBy: data.ret_value.responseBy,
                    internalContact: data.ret_value.internalContact,
                    broker: data.ret_value.broker,
                    dealCode: data.ret_value.deal,
                    nmFacility: data.ret_value.nmFacility,
                    nmObligor: data.ret_value.nmObligor,
                    projectName: data.ret_value.projectName,
                });
                setHistorymsg(data.ret_value.historical);

            })
            .catch((error) => {
                mc.error("Erro executando consulta\n" + error);
                console.error('fitPostSummary - Error:', error);
            });
        loading.stop();
    };

    function handleApproval() {
        loading.start();
        fitinsur.setAuthToken(authContext.token);
        fitinsur.endorsementOffRiskApprove(props.match.params.idOperation, userComments)
            .then(response => response.json())
            .then(resp => {
                if (resp.ret_code === 200) {
                    loading.stop();
                    history.push('/policies')
                } else {
                    loading.stop();
                    mc.error(resp.ret_msg_details);
                }
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleApproval.name}\n` + error);
                console.error('fitPostAproval - Error:', error);
            })
        loading.stop();
    };

    function handleReject() {
        loading.start();
        fitinsur.setAuthToken(authContext.token);
        fitinsur.endorsementOffRiskReject(props.match.params.idOperation, userComments)
            .then(x => x.json())
            .then(resp => {
                if (resp.ret_code === 200) {
                    loading.stop();
                    mc.success("Approval - Endorsement Rejected");
                    history.push('/policies')
                } else {
                    loading.stop();
                    mc.error(resp.ret_msg_details);
                }
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleReject.name}\n` + error);
                console.error('fitPostReject - Error:', error);
            });
        loading.stop();
    };

    function handleIsApprovedEndorsementOffRisk() {
        loading.start();

        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestIsApprovedEndorsementOffRisk(props.match.params.idOperation)
            .then(response => response.json())
            .then(resp => {
                if (resp.ret_code === 200) {
                    loading.stop();
                    if (resp.ret_value) {
                        setIsApproved(resp.ret_value.isApproved);
                    }
                } else {
                    mc.error(resp.ret_msg_details);
                    loading.stop();
                }
            })
            .catch((error) => {
                mc.error("Erro executando consulta\n" + error);
                console.error('fitIsEnabledPolicy - Error:', error);
                loading.stop();
            });

    };

    ////////////  Dialog ///////////////// 
    const [typeDialog, setTypeDialog] = useState(null);
    const [dialog, setDialog] = useState({
        visible: false,
        title: '',
        icon: 'exclamation',
        args: null
    });

    function handleCancel() {
        setUserComments("");
        setDialog({
            visible: false,
            title: '',
            icon: 'exclamation',
            args: null
        })
    }

    function handleDialog(type) {
        if (type === "Approve") {
            setTypeDialog("Approve");
            setDialog({
                visible: true,
                title: "APPROVE - ENDORSEMENT",
                icon: "TimesCircle",
                args: null,
            })
        } else if (type === "Reject") {
            setTypeDialog("Reject");
            setDialog({
                visible: true,
                title: "REJECT - ENDORSEMENT",
                icon: "TimesCircle",
                args: null,
            })
        } else if (type === "Cancel") {
            setTypeDialog("Cancel");
            setDialog({ visible: true })
        }
    };

    function handleSignatureRequest() {
        history.push(`/broking/endorsement-off-risk-contacts-selection/${props.match.params.idOperation}`, { idProduct: props.location?.state?.idProduct || null });
    }

    const goToLoginPage = () => {
        history.push('login');
    };

    async function handleOperationInfo() {
        loading.start()
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestOperationInfo(props.match.params.idOperation)
          .then(response => response.json())
          .then(response => {
            setIsBound(response?.isBound);
            loading.stop();
          })
          .catch((error) => {
            mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
            loading.stop();
          });
    }

    useEffect(() => {
        loading.start();
        if (authContext.status !== true) {
            mc.error("Usuário não autenticado");
            goToLoginPage();
            return;
        }
        else {
            fitinsur.setAuthToken(authContext.token);

        };

        //colocar chamadas necessárias no periodo de loading da tela
        let v = handleHistoryMessage()
        if (formik.current) {
            formik.current?.setFieldValue('dealAnalisysInformation', v)
        }
        loading.stop();
    }, [historymsg])

    useEffect(() => {
        if (authContext.status !== true) {
            mc.error("User is not authenticated, please Login");
            loading.stop();
            goToLoginPage();
            return;
        }
        else {
            fitinsur.setAuthToken(authContext.token);
            loading.stop();
        };

        handleIsApprovedEndorsementOffRisk();
        handleGetModal();
        handleSummary();
        requestBindMessage();
        handleOperationInfo();
    }, []);


    return (
        <Layout
            idOperation={props.match?.params?.idOperation}
            title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
            subtitle={summary.dealCode ? summary.dealCode : "Broking code"}>

            <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />

            <BrokingSummary data={summary} />
            <ContentCard title={'APPROVAL ENDORSEMENT - OFF RISK'} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
                {dialog.visible && typeDialog === 'Cancel' ?
                    (<DialogComponentCancel history={history} show={dialog.visible && typeDialog === 'Cancel'} setDialog={setDialog} idOperation={props.match?.params?.idOperation} />) :
                    (<DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible && typeDialog !== 'Cancel'} setDialog={setDialog}>
                        {typeDialog === 'Approve' ?
                            <ContentTextArea>
                                <p>Deal Analysis information</p>
                                <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
                                <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
                                <DialogConfirm onClick={() => handleApproval()}>CONFIRM</DialogConfirm>
                            </ContentTextArea>
                            : typeDialog === 'Reject' ?
                                <ContentTextArea>
                                    <p>Deal Analysis information</p>
                                    <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
                                    <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
                                    <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
                                </ContentTextArea>
                                : ""
                        }
                    </DialogComponent>)
                }


                <Formik
                    innerRef={formik}
                    initialValues={{
                        offRiskMessage: 'Loading...',
                        dealAnalisysInformation: ''
                    }}
                    onSubmit={''}>
                    {formikProps => (
                        <Form>
                            <Row>
                                <Col>
                                    <Field
                                        label={'*Endorsement - Message'}
                                        name={'offRiskMessage'}
                                        value={formikProps.values.offRiskMessage}
                                        onChange={(e) => formikProps?.setFieldValue('offRiskMessage', e)}
                                        disabled
                                        component={TextField}
                                    />
                                </Col>
                            </Row>
                            <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                            {isApproved ?
                                <>
                                    <Label>Deal Analysis Information</Label>
                                    <TextArea
                                        readOnly
                                        value={handleHistoryMessage()} />
                                    <ButtonContainer>
                                        <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                                        <HasPermission permission={!isBound}>
                                            <ButtonContent>
                                                <LostCancelButton idOperation={props.match?.params?.idOperation} />
                                                <HasPermission permission={props.permissions.EXECUTION}>
                                                    <Button
                                                        style={{ marginLeft: "10px" }}
                                                        primary
                                                        id="btnSignatureRequest"
                                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleSignatureRequest() }}>
                                                        REQUEST SIGNATURE
                                                    </Button>
                                                </HasPermission>
                                            </ButtonContent>
                                        </HasPermission>
                                    </ButtonContainer>
                                </>
                                :
                                <ButtonContainer>
                                    <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                                    <HasPermission permission={!isBound}>
                                        <ButtonContent>
                                            <HasPermission permission={props.permissions.ENDORSEMENT_PACK_APPROVE_REJECT}>
                                                <Button
                                                    secundary
                                                    type="submit"
                                                    id="btnReject"
                                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Reject"); }}>
                                                    REJECT
                                                </Button>
                                                <Button
                                                    style={{ marginLeft: "10px" }}
                                                    type="submit"
                                                    primary
                                                    id="btnSubmitApproved"
                                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Approve"); }}>
                                                    APPROVE
                                                </Button>
                                            </HasPermission>
                                        </ButtonContent>
                                    </HasPermission>
                                </ButtonContainer>
                            }
                        </Form>
                    )}
                </Formik>
            </ContentCard>
            {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
        </Layout>
    );
}
